import {
  getRawAddEventListener,
  getRawRemoveEventListener,
} from '../../../shares/lib/rawEventListener';
import eventType from '../../../shares/enums/eventType';
import eventEmitters from '../../../shares/lib/eventEmitters';
import { getSDKConfig } from '../../../shares/lib/getSDKConfig';

let isSubscribed = false;

export async function subscribeToMessages() {
  if (!isSubscribed) {
    const rawAddEventListener = getRawAddEventListener();
    rawAddEventListener('message', handleMessages);
    isSubscribed = true;
  }
}

export async function unsubscribeToMessages() {
  if (isSubscribed) {
    const rawRemoveEventListener = getRawRemoveEventListener();
    rawRemoveEventListener('message', handleMessages);
    isSubscribed = false;
  }
}

function handleMessages(message: MessageEvent) {
  const { simulate } = getSDKConfig();

  const isValidOrigin = simulate?.iframeSourceUrl?.startsWith(message.origin);

  if (!isValidOrigin) {
    return;
  }

  if (message.data.type === 'refreshBalance' && simulate?.onRefreshBalance) {
    simulate?.onRefreshBalance();
    eventEmitters(eventType.SIMULATE_REFRESHBALANCE, 'Simulate');
  }

  if (
    message.data.type === 'gameAnimationStart' &&
    simulate?.onAnimationStart
  ) {
    simulate?.onAnimationStart();
    eventEmitters(eventType.SIMULATE_GAMEANIMATIONSTART, 'Simulate');
  }
}
